import React, { Component } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";
import {
  Button,
  GridColumn,
  GridRow,
  Loader,
  Utils,
  Toastr,
} from "arv-reactcomponents";
import NeftList from "../../NeftList";
import BackButton from "../../BackButton";
import NextButton from "../../NextButton";
import { RETURNS, CANCEL } from "npmlinks-constants";

const { RETURN_REFUND, RETURN_ELIGIBLE, RETURN_REASONS } = RETURNS;
const { CANCEL_ELIGIBLE, CANCEL_REASONS } = CANCEL;

@inject("ReturnStore")
@observer
class ReturnOrCancelRefund extends Component {
  static renderLoader() {
    return (
      <div className="nw-bodyoverlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
    };

    this.addNeft = this.addNeft.bind(this);
    this.submit = this.submit.bind(this);
    this.addNeft = this.addNeft.bind(this);
    this.selectView = this.selectView.bind(this);
    this.selectNeft = this.selectNeft.bind(this);
  }

  get neftList() {
    return toJS(this.props.ReturnStore.neftList);
  }

  get shouldEnableNextButton() {
    if (
      this.props.ReturnStore.isNeftNeeded &&
      !this.props.ReturnStore.selectedNeftId
    )
      return false;
    return true;
  }

  submit() {
    this.setState({ isLoaded: true });
    let apiResponse = null;
    if (this.props.type === CANCEL_ELIGIBLE) {
      apiResponse = this.props.ReturnStore.makeCancel();
    } else {
      apiResponse = this.props.ReturnStore.makeReturn();
    }
    apiResponse.then(
      response => {
        console.log(
          `Response from Return final API${JSON.stringify(response)}`,
        );
        this.setState({ isLoaded: false });
        this.props.onSubmit();
        this.props.next();
      },
      error => {
        this.setState({ isLoaded: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: RETURN_REASONS.ERROR_MESSAGE,
          timeout: 3000,
        });
        console.log(`Error from Return final API${JSON.stringify(error)}`);
      },
    );
  }

  addNeft(e) {
    e.preventDefault();
    this.props.inner();
  }

  selectNeft(e, selectedNeftId) {
    e.preventDefault();
    this.props.ReturnStore.setReturnNeftId(selectedNeftId);
  }

  getTitle() {
    return this.props.type === CANCEL_ELIGIBLE
      ? CANCEL_REASONS.TITLE
      : RETURN_REFUND.TITLE;
  }

  selectView() {
    const { type, ReturnStore } = this.props;
    const selectedOrDefaultNeftId =
      ReturnStore.selectedNeftId ||
      (this.neftList && this.neftList[0] && this.neftList[0].id);
    if (ReturnStore.isNeftNeeded && type === RETURN_ELIGIBLE) {
      return (
        <section className="nw-returnrefund-neftwrapper">
          <div className="nw-returnrefund-txt">
            {RETURN_REFUND.REFUND_INTO_TEXT}
          </div>
          <NeftList.component
            neftList={this.neftList}
            selectedNeftId={selectedOrDefaultNeftId}
            isButton
            selectNeft={this.selectNeft}
          />
          <Button
            className="nwc-btn-primary-txt nw-returnrefund-addneftbtn"
            onClick={this.addNeft}
          >
            {RETURN_REFUND.ADD_NEFT_TEXT}
          </Button>
        </section>
      );
    }
    return (
      <section className="nw-returnrefund-txtwrapper">
        <div className="nw-returnrefund-txt">
          {RETURN_REFUND.REFUND_INTO_TEXT}
        </div>
        <div className="nw-returnrefund-backtosource">
          {ReturnStore.refundAmount
            ? `${RETURN_REFUND.REFUND_INTO_SOURCE_TEXT}`
            : `NA`}
        </div>
      </section>
    );
  }

  render() {
    const { previous, ReturnStore } = this.props;
    const { isLoaded } = this.state;
    return (
      <GridRow>
        {isLoaded && ReturnOrCancelRefund.renderLoader()}
        <GridColumn className="nw-returnrefundamount-container">
          <BackButton.component
            previous={previous}
            className="nw-returns-backbtn"
          />
          <h2 className="nw-return-title">{this.getTitle()}</h2>
        </GridColumn>
        <GridColumn className="nw-returnrefundamount-wrapper">
          <div className="nw-returnrefundamount-tile">
            {RETURN_REFUND.REFUND_AMOUNT_TITLE}
          </div>
          <div className="nw-returnrefundamount-cash">
            {`Rs.${ReturnStore.refundAmount}`}
          </div>
          {this.selectView()}
        </GridColumn>
        <NextButton.component
          className="nw-returns-nxtbtn"
          next={this.submit}
          disabled={!this.shouldEnableNextButton}
        />
      </GridRow>
    );
  }
}

ReturnOrCancelRefund.defaultProps = {
  inner: PropTypes.func,
  next: PropTypes.func,
  previous: PropTypes.func,
  onSubmit: Utils.noop,
};

ReturnOrCancelRefund.wrappedComponent.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  inner: PropTypes.func,
  type: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  ReturnStore: PropTypes.shape({
    isNeftNeeded: PropTypes.bool.isRequired,
    selectedNeftId: PropTypes.string,
    neftList: PropTypes.shape({}),
    makeReturn: PropTypes.func.isRequired,
    downloadForm: PropTypes.func.isRequired,
    makeCancel: PropTypes.func.isRequired,
    setReturnNeftId: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ReturnStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReturnOrCancelRefund.wrappedComponent,
  component: ReturnOrCancelRefund,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/ReturnOrCancelRefund/index.js